// Helper hook: should we render Google AdSense on the website right now?
//
// Returns false when:
//  • Running inside the Android Capacitor app (we use AdMob there, not AdSense).
//  • The user is signed in AND has purchased credits (paid users see no ads).
//  • The AdSense client ID env var is missing (e.g. before approval).
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { isAndroidApp } from "@/lib/platform";

export const ADSENSE_CLIENT_ID =
  import.meta.env.VITE_ADSENSE_CLIENT_ID || "";
export const ADSENSE_SLOT_BANNER =
  import.meta.env.VITE_ADSENSE_SLOT_BANNER || "";
export const ADSENSE_SLOT_INARTICLE =
  import.meta.env.VITE_ADSENSE_SLOT_INARTICLE || "";

export function useShouldShowAds(): boolean {
  const { user } = useAuth();
  const [isPaid, setIsPaid] = useState<boolean | null>(null);

  useEffect(() => {
    if (!user) {
      setIsPaid(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("profiles")
        .select("credits_purchased_total")
        .eq("user_id", user.id)
        .maybeSingle();
      if (cancelled) return;
      setIsPaid(Number(data?.credits_purchased_total ?? 0) > 0);
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  if (isAndroidApp()) return false;
  if (!ADSENSE_CLIENT_ID) return false;
  if (isPaid === null) return false; // wait for check (avoids flicker)
  if (isPaid) return false;
  return true;
}
